import React from "react";
import { Route, Router, Switch } from "react-router";
import { createHashHistory } from "history";
import { RefundRequestsScreen } from "./screens/RefundRequestsScreen";
import { RefundRequestScreen } from "./screens/RefundRequestScreen";

export const AppRouterContext = React.createContext({
  routerProps: {
    history: {
      push: (route: string) => {},
    },
    location: {
      pathname: "/",
    },
    match: {
      params: {} as any,
    },
  },
});

export const AppRouter: React.FC = () => {
  const history = createHashHistory();

  return (
    <Router history={history}>
      <Switch>
        <Route
          exact={true}
          path="/"
          render={routerProps => (
            <AppRouterContext.Provider value={{ routerProps }}>
              <RefundRequestsScreen />
            </AppRouterContext.Provider>
          )}
        />
        <Route
          exact={true}
          path="/:id"
          render={routerProps => (
            <AppRouterContext.Provider value={{ routerProps }}>
              <RefundRequestScreen />
            </AppRouterContext.Provider>
          )}
        />
      </Switch>
    </Router>
  );
};
